module.exports = __webpack_public_path__ + "static/young-leader-photo-julian_huff-cc91a89d14d80e141e0a16629aa56007.jpg";